import React, { FC, useCallback } from 'react'
import { Grid } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  itemBlock: {
    color: 'white',
    fontSize: '16px',
    width: ({ width }: Pick<SingleLabelProps, 'width'>) => width || '215px',
    '& .grey': {
      color: 'rgba(255,255,255,0.64)',
    },
    '& .green': {
      color: theme.palette.secondary.main,
    },
    '& .red': {
      color: '#ED2A2A',
    },
    '& .orange': {
      color: '#F8BB4D',
    },
  },
}))

interface SingleLabelProps {
  labelValue: string
  width?: number | string
}

export const SingleLabel: FC<SingleLabelProps> = ({ labelValue, width }) => {
  const classes = useStyles({ width })

  const setColor = useCallback((values: string) => {
    let color = ''
    switch (true) {
      case values === 'Failed':
        color = 'red'
        break
      case values === 'Pass':
        color = 'green'
        break
      case values === 'Not Initial':
        color = 'grey'
        break
      default:
        color = 'white'
    }
    return color
  }, [])

  return (
    <Grid container className={classes.itemBlock}>
      <Grid item className={setColor(labelValue)}>
        {labelValue}
      </Grid>
    </Grid>
  )
}
